// v642.7: Mobile chat strip — Discord-mobile pattern.
//
// A persistent thin bar above the bottom HUD showing the most recent
// chat line. Tap to open the full mobile chat overlay. Auto-fades when
// nothing new has arrived for a while so it doesn't crowd the map.

import React, { useEffect, useState } from 'react';

const MobileChatStrip = ({ chatMessages = [], onOpen, currentName }) => {
  const last = chatMessages.length > 0 ? chatMessages[chatMessages.length - 1] : null;
  const [pulse, setPulse] = useState(false);

  // Brief pulse when a new message arrives.
  useEffect(() => {
    if (!last) return;
    setPulse(true);
    const t = setTimeout(() => setPulse(false), 1500);
    return () => clearTimeout(t);
  }, [last?.timestamp, last?.message, last?.content]);

  if (!last) {
    return (
      <button
        type="button"
        onClick={onOpen}
        className="m-chat-strip m-chat-strip-empty"
        aria-label="Open chat"
      >
        💬 <span style={{ opacity: 0.6 }}>Tap to chat…</span>
      </button>
    );
  }

  const sender = last.characterName || last.sender || 'system';
  const text = last.message || last.content || '';
  const isSelf = sender === currentName;
  const trimmed = text.length > 80 ? text.slice(0, 78) + '…' : text;

  return (
    <button
      type="button"
      onClick={onOpen}
      className={`m-chat-strip${pulse ? ' m-chat-strip-pulse' : ''}`}
      aria-label="Open chat"
    >
      <span className="m-chat-strip-icon">💬</span>
      <span className="m-chat-strip-name" style={{ color: isSelf ? '#9eb8ff' : '#ffd96b' }}>
        {sender}:
      </span>
      <span className="m-chat-strip-text">{trimmed}</span>
    </button>
  );
};

export default MobileChatStrip;
